import type { StatusBadgeVariant } from "@/components/shared/StatusBadge";
import type { ProfessionalPayoutStatus } from "@/services/professionalEarningsService";

export function statusLabelKey(status: ProfessionalPayoutStatus): string {
  switch (status) {
    case "pending":
      return "statusPending";
    case "processing":
      return "statusProcessing";
    case "paid":
      return "statusPaid";
    case "cancelled":
      return "statusCancelled";
  }
}

export function statusBadgeVariant(status: ProfessionalPayoutStatus): StatusBadgeVariant {
  switch (status) {
    case "paid":
      return "success";
    case "processing":
      return "info";
    case "cancelled":
      return "softDanger";
    case "pending":
      return "warning";
  }
}
